AuthRoute = require 'mixins/authenticated-route'

{ timedPromise } = require 'utils/rsvp'

App.LoyaltyProgramsIndexRoute = Em.Route.extend AuthRoute,
  model: ->
    @modelFor('loyalty-programs')


  afterModel: (model) ->
    adapter = @get('store').adapterFor('application')
    host = adapter.get('host')
    headers = adapter.get('headers')
    URL = "#{host}/api/system_info/loyalty_program_kinds"
    
    ajaxProps =
      url: URL
      headers: headers
      type: 'GET'
    
    Em.$.ajax(ajaxProps).then (result) =>
      model.set('additionalInfo', result)
      if not Ember.isEmpty model.content
        model.content.forEach (childModel) =>
          childKindInfo = result.find (data) => data.name == childModel.get('kind')
          childModel.set('additionalInfo', result)
          childModel.set('selectedKind',{
            childKindInfo,
            translation: childKindInfo.locales[Em.I18n.locale]
          })
